const load = () => {
  if (process.env.REACT_APP_SEGMENT_WRITE_KEY) {
    window.analytics.load(process.env.REACT_APP_SEGMENT_WRITE_KEY);
  }
}

const pageView = () => {
  try {
    window.analytics.page();
  } catch (e) {
    console.log(e)
  }
}

const identify = (analytics_id) => {
  try {
    return window.analytics.identify(analytics_id);
  } catch (e) {
    console.log(e)
  }
}

const track = (eventName, properties, options, callback) => {
  try {
    return window.analytics.track(eventName, properties, options, callback)
  } catch (e) {
    console.log(e)
  }
}

const reset = () => {
  try {
    return window.analytics.reset();
  } catch (e) {
    console.log(e)
  }
}

const analytics = {
  load,
  pageView,
  identify,
  track,
  reset,
}

export default analytics;